var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "section",
        [
          _c("AdvanceTable", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            ref: "advanceTable",
            attrs: {
              url: "crm/product",
              height: _vm.window.height - 310,
              columns: _vm.columns,
              pageOptions: [50, 100, 200],
              defaultPageSize: 50,
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [_vm._v(" " + _vm._s(_vm.$t("Products")) + " ")]
                },
                proxy: true,
              },
              {
                key: "cell(origin_countries)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.value
                            .map(function (c) {
                              return c.countryCode
                            })
                            .join(", ")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(destination_countries)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.value
                            .map(function (c) {
                              return c.countryCode
                            })
                            .join(", ")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(is_temporary)",
                fn: function (row) {
                  return [
                    row.value
                      ? _c("div", [_vm._v(" Yes ")])
                      : _c("div", [_vm._v(" No ")]),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    row.item.is_temporary
                      ? _c(
                          "div",
                          [
                            _vm.getCrmProfile().role_id === 1
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: { icon: "el-icon-document-copy" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.mergeProductShow(row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Merge")))]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    !row.item.is_temporary &&
                    (_vm.getCrmProfile().role_id === 1 ||
                      _vm.getCrmProfile().role_id === 2)
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-link",
                              {
                                attrs: { icon: "el-icon-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editProductShow(row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Edit")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "button",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-1",
                        attrs: { variant: "info" },
                        on: {
                          click: function ($event) {
                            return _vm.syncProducts("K_PARCEL")
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "RefreshCwIcon" },
                        }),
                        _c("span", { staticClass: "align-middle" }, [
                          _vm._v(_vm._s(_vm.$t("Sync K-parcel"))),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-1",
                        attrs: { variant: "info" },
                        on: {
                          click: function ($event) {
                            return _vm.syncProducts("K_ENGINE")
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "RefreshCwIcon" },
                        }),
                        _c("span", { staticClass: "align-middle" }, [
                          _vm._v(_vm._s(_vm.$t("Sync K-engine"))),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-merge-product",
            "hide-footer": "",
            size: "xl",
            title: _vm.$t("Merge Temporary Product"),
          },
          model: {
            value: _vm.isMergeDialogShow,
            callback: function ($$v) {
              _vm.isMergeDialogShow = $$v
            },
            expression: "isMergeDialogShow",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              staticClass: "card p-2",
            },
            [
              _c(
                "el-form",
                [
                  _c(
                    "b-form-group",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-minus" }),
                        _vm._v(_vm._s(_vm.$t("Temporary Product")) + " * "),
                      ]),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c("label", [_vm._v("ID")]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.mergeForm.temporaryProduct.id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.mergeForm.temporaryProduct,
                                      "id",
                                      $$v
                                    )
                                  },
                                  expression: "mergeForm.temporaryProduct.id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Code")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.mergeForm.temporaryProduct.code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.mergeForm.temporaryProduct,
                                      "code",
                                      $$v
                                    )
                                  },
                                  expression: "mergeForm.temporaryProduct.code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Name")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.mergeForm.temporaryProduct.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.mergeForm.temporaryProduct,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "mergeForm.temporaryProduct.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Type")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value:
                                    _vm.mergeForm.temporaryProduct.product_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.mergeForm.temporaryProduct,
                                      "product_type",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "mergeForm.temporaryProduct.product_type",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Origin")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.mergeForm.temporaryProduct.origin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.mergeForm.temporaryProduct,
                                      "origin",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "mergeForm.temporaryProduct.origin",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "2" } },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("Destination"))),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value:
                                    _vm.mergeForm.temporaryProduct.destination,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.mergeForm.temporaryProduct,
                                      "destination",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "mergeForm.temporaryProduct.destination",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "b-form-group",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", align: "center" } },
                            [
                              _c("feather-icon", {
                                staticClass: "text-muted",
                                attrs: { icon: "ArrowDownIcon", size: "36" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-plus" }),
                        _vm._v(_vm._s(_vm.$t("Permanent Product")) + " * "),
                      ]),
                      _c("validation-provider", {
                        attrs: { name: "Permanent Product", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "Please Select Product",
                                    },
                                    on: { change: _vm.selectPermanentProduct },
                                    model: {
                                      value: _vm.mergeForm.permanentProduct.id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.mergeForm.permanentProduct,
                                          "id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mergeForm.permanentProduct.id",
                                    },
                                  },
                                  _vm._l(
                                    _vm.productList.filter(function (p) {
                                      return !p.is_temporary
                                    }),
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          value: item.id,
                                          label:
                                            "ID: " +
                                            item.id +
                                            " / Code: " +
                                            item.code +
                                            " / Type: " +
                                            item.product_type +
                                            " / Origin: " +
                                            item.origin +
                                            " / Destination: " +
                                            item.destination,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c("label", [_vm._v("ID")]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.mergeForm.permanentProduct.id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.mergeForm.permanentProduct,
                                                "id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mergeForm.permanentProduct.id",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.$t("Code"))),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.mergeForm.permanentProduct
                                                .code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.mergeForm.permanentProduct,
                                                "code",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mergeForm.permanentProduct.code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.$t("Name"))),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.mergeForm.permanentProduct
                                                .name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.mergeForm.permanentProduct,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mergeForm.permanentProduct.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.$t("Type"))),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.mergeForm.permanentProduct
                                                .product_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.mergeForm.permanentProduct,
                                                "product_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mergeForm.permanentProduct.product_type",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.$t("Origin"))),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.mergeForm.permanentProduct
                                                .origin,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.mergeForm.permanentProduct,
                                                "origin",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mergeForm.permanentProduct.origin",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c("label", [
                                          _vm._v(_vm._s(_vm.$t("Destination"))),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.mergeForm.permanentProduct
                                                .destination,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.mergeForm.permanentProduct,
                                                "destination",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mergeForm.permanentProduct.destination",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        float: "right",
                        margin: "20px 0",
                        width: "200px",
                        background: "#66b1ff",
                        border: "#66b1ff",
                        "margin-left": "20px",
                      },
                      attrs: { type: "primary", icon: "el-icon-check" },
                      on: {
                        click: function ($event) {
                          return _vm.mergeProduct()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Merge Products")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-update-product",
            "hide-footer": "",
            size: "xl",
            title: _vm.$t("Update Product"),
          },
          model: {
            value: _vm.isEditDialogShow,
            callback: function ($$v) {
              _vm.isEditDialogShow = $$v
            },
            expression: "isEditDialogShow",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              staticClass: "card p-2",
            },
            [
              _c(
                "el-form",
                [
                  _c(
                    "b-form-group",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("label", [_vm._v("ID")]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.editForm.id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editForm, "id", $$v)
                                  },
                                  expression: "editForm.id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Code")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.editForm.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editForm, "code", $$v)
                                  },
                                  expression: "editForm.code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Name")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.editForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editForm, "name", $$v)
                                  },
                                  expression: "editForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Type")))]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.editForm.product_type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editForm, "product_type", $$v)
                                  },
                                  expression: "editForm.product_type",
                                },
                              }),
                            ],
                            1
                          ),
                          false
                            ? _c(
                                "b-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Origin"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.editForm.origin,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.editForm, "origin", $$v)
                                      },
                                      expression: "editForm.origin",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          false
                            ? _c(
                                "b-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Destination"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.editForm.destination,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editForm,
                                          "destination",
                                          $$v
                                        )
                                      },
                                      expression: "editForm.destination",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(_vm._s(_vm.$t("Origins")) + " "),
                                _c("i", { staticClass: "el-icon-arrow-right" }),
                              ]),
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.editForm.origin,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.editForm, "origin", $$v)
                                      },
                                      expression: "editForm.origin",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._l(
                                _vm.countryGroups,
                                function (countries, continental) {
                                  return false
                                    ? _c(
                                        "div",
                                        { key: continental },
                                        [
                                          _c(
                                            "b-card",
                                            {
                                              staticClass: "mb-1",
                                              attrs: { "no-body": "" },
                                            },
                                            [
                                              _c(
                                                "b-card-header",
                                                {
                                                  staticClass: "p-0",
                                                  attrs: {
                                                    "header-tag": "header",
                                                    role: "tab",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-toggle",
                                                          rawName: "v-b-toggle",
                                                          value:
                                                            "accordion-" +
                                                            continental,
                                                          expression:
                                                            "'accordion-' + continental",
                                                        },
                                                      ],
                                                      staticStyle: {
                                                        "text-align": "left",
                                                      },
                                                      attrs: {
                                                        block: "",
                                                        variant: "light",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(continental)
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-collapse",
                                                {
                                                  attrs: {
                                                    id:
                                                      "accordion-" +
                                                      continental,
                                                    accordion: "my-accordion-1",
                                                    role: "tabpanel",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-card-body",
                                                    [
                                                      _c(
                                                        "b-form-checkbox",
                                                        {
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleSelectAll(
                                                                "origin_countries",
                                                                continental
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.checkAll[
                                                                "origin_countries"
                                                              ][continental],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.checkAll[
                                                                  "origin_countries"
                                                                ],
                                                                continental,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "checkAll['origin_countries'][continental]",
                                                          },
                                                        },
                                                        [_vm._v("Select ALL")]
                                                      ),
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          attrs: {
                                                            id: "checkbox-group-1",
                                                            name: "checkbox-group-1",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.editForm
                                                                .origin_countries,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.editForm,
                                                                "origin_countries",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "editForm.origin_countries",
                                                          },
                                                        },
                                                        _vm._l(
                                                          countries,
                                                          function (country) {
                                                            return _c(
                                                              "b-form-checkbox",
                                                              {
                                                                key: country,
                                                                attrs: {
                                                                  value: {
                                                                    countryCode:
                                                                      country,
                                                                  },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .countryMap[
                                                                      country
                                                                    ]
                                                                      ? _vm
                                                                          .countryMap[
                                                                          country
                                                                        ].name
                                                                      : ""
                                                                  ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      country
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(_vm._s(_vm.$t("Destination")) + " "),
                                _c("i", { staticClass: "el-icon-arrow-right" }),
                              ]),
                              _vm._l(
                                _vm.countryGroups,
                                function (countries, continental) {
                                  return _c(
                                    "div",
                                    { key: continental },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "mb-1",
                                          attrs: { "no-body": "" },
                                        },
                                        [
                                          _c(
                                            "b-card-header",
                                            {
                                              staticClass: "p-0",
                                              attrs: {
                                                "header-tag": "header",
                                                role: "tab",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-toggle",
                                                      rawName: "v-b-toggle",
                                                      value:
                                                        "accordion-" +
                                                        continental,
                                                      expression:
                                                        "'accordion-' + continental",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    "text-align": "left",
                                                  },
                                                  attrs: {
                                                    block: "",
                                                    variant: "light",
                                                  },
                                                },
                                                [_vm._v(_vm._s(continental))]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-collapse",
                                            {
                                              attrs: {
                                                id: "accordion-" + continental,
                                                accordion: "my-accordion-2",
                                                role: "tabpanel",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-card-body",
                                                [
                                                  _c(
                                                    "b-form-checkbox",
                                                    {
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSelectAll(
                                                            "destination_countries",
                                                            continental
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.checkAll[
                                                            "destination_countries"
                                                          ][continental],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.checkAll[
                                                              "destination_countries"
                                                            ],
                                                            continental,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "checkAll['destination_countries'][continental]",
                                                      },
                                                    },
                                                    [_vm._v("Select ALL")]
                                                  ),
                                                  _c(
                                                    "b-form-checkbox-group",
                                                    {
                                                      attrs: {
                                                        id: "checkbox-group-2",
                                                        name: "checkbox-group-2",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editForm
                                                            .destination_countries,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editForm,
                                                            "destination_countries",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editForm.destination_countries",
                                                      },
                                                    },
                                                    _vm._l(
                                                      countries,
                                                      function (country) {
                                                        return _c(
                                                          "b-form-checkbox",
                                                          {
                                                            key: country,
                                                            attrs: {
                                                              value: {
                                                                countryCode:
                                                                  country,
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.countryMap[
                                                                  country
                                                                ]
                                                                  ? _vm
                                                                      .countryMap[
                                                                      country
                                                                    ].name
                                                                  : ""
                                                              ) +
                                                                " - " +
                                                                _vm._s(country)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        float: "right",
                        margin: "20px 0",
                        width: "200px",
                        background: "#66b1ff",
                        border: "#66b1ff",
                        "margin-left": "20px",
                      },
                      attrs: { type: "primary", icon: "el-icon-check" },
                      on: {
                        click: function ($event) {
                          return _vm.updateProduct()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Update")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }